import { Grid } from "@mui/material";
import { useUserInfo } from "context/user";
import { useAppServices } from "hook/services";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "./accountDetailTabs.css";

const Business = () => {
  const [businessDetail, setBusinessDetail] = useState([]);
  const AppService = useAppServices();
  const {id} = useParams();

  useEffect(() => {
    const fetchBusiness = async () => {
      if (!id) {
        setBusinessDetail([]);
        return;
      }
      try {
        const { response } = await AppService.claim_business.Get({
          query: `account_id=${id}&status=approved`,
        });
        const list = Array.isArray(response?.data) ? response.data : [];
        setBusinessDetail(list);
      } catch (error) {
        console.error("Error fetching business details:", error);
        setBusinessDetail([]);
      }
    };

    fetchBusiness();
  }, [id]);

  return (
    <div className="sd-account-detail-tab sd-consumers-followed-business">
      <Grid item xs={12}>
        <div className="sd-consumers-followed-business__header d-flex justify-content-between">
          <p style={{ flex: 1 }}>Business Name</p>
          <p style={{ flex: 1 }}>Business Reference</p>
          <p style={{ flex: 1 }}>Email</p>
          <p style={{ flex: 1 }}>Status</p>
        </div>

        {businessDetail?.map((event, index) => (
          <div
            className="d-flex justify-content-between sd-consumers-followed-business__row"
            style={{
              margin: "12px 0",
              backgroundColor: "#f8f9fa",
              padding: "12px 10px",
              borderRadius: "10px",
            }}
            key={index}
          >
            <p style={{ flex: 1 }}>{event?.business_name}</p>
            <p style={{ flex: 1 }}>{event?.business_reference}</p>
            <p style={{ flex: 1 }}>{event?.email}</p>
            <p style={{ flex: 1 }}>{event?.status}</p>
          </div>
        ))}
      </Grid>
    </div>
  );
};

export default Business;
